// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RqOwf","newExpiryDate":"styles_newExpiryDate__2bhqM","footer":"styles_footer__3R_Yi"};